import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTempUserDetails } from '../../../../actions/admin';
import CircularProgress from '@mui/material/CircularProgress';
import AdminContainer from 'containers/AdminContainer';
import Button from '@mui/material/Button';
import moment from 'moment';
import { Col, Row } from 'reactstrap';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Pagination from '@mui/material/Pagination';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DatePickerForBuyerPerfomance from 'app/routes/sellerPerformance/datepicker';

const SESSIONS_PER_PAGE = 10;

function GuestUserDetails(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sessionPage, setSessionPage] = useState(1);
  const [expanded, setExpanded] = useState(false);
  const [csvDialog, setCsvDialog] = useState(false);
  const [fromDate, setFromDate] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  useEffect(() => {
    props.getTempUserDetails({ data: { userId: id } });
  }, [id]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSessionPageChange = (event, page) => {
    setSessionPage(page);
    setExpanded(false);
  };

  const { tempUserDetails, loading } = props;
  const user = tempUserDetails && tempUserDetails.detail ? tempUserDetails.detail : null;

  const handleDateChange = (date, key) => {
    if (key === 'from') {
      setFromDate(moment(date).format('YYYY-MM-DD'));
    } else {
      setToDate(moment(date).format('YYYY-MM-DD'));
    }
  };

  const openCsvDialog = () => {
    setFromDate(moment().subtract(1, 'months').format('YYYY-MM-DD'));
    setToDate(moment().format('YYYY-MM-DD'));
    setCsvDialog(true);
  };

  const exportCSV = () => {
    if (!user || !user.sessions) return;

    const from = moment(fromDate).startOf('day');
    const to = moment(toDate).endOf('day');

    const rows = [['Session #', 'Session Start', 'Session End', 'Status', 'Product Searched']];

    user.sessions.forEach((session, index) => {
      const sessionDate = session.login_at ? moment(session.login_at) : null;
      if (!sessionDate || !sessionDate.isBetween(from, to, undefined, '[]')) return;

      const sessionNumber = user.sessions.length - index;
      const start = session.login_at ? moment(session.login_at).format('DD MMM YYYY, hh:mm A') : '-';
      const end = session.logout_at ? moment(session.logout_at).format('DD MMM YYYY, hh:mm A') : '-';
      const isActive = session.logout_at && new Date(session.logout_at) > new Date();
      const status = isActive ? 'Active' : 'Expired';

      const uniqueLogs = session.searchLogs
        ? session.searchLogs.filter((log, i, arr) =>
            arr.findIndex(l => (l.key || '').toLowerCase() === (log.key || '').toLowerCase()) === i
          )
        : [];

      if (uniqueLogs.length > 0) {
        uniqueLogs.forEach((log) => {
          rows.push([sessionNumber, start, end, status, log.key || '-']);
        });
      } else {
        rows.push([sessionNumber, start, end, status, 'No searches']);
      }
    });

    const csvContent = rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Guest_User_${user.name || user.phone || 'unknown'}(${fromDate} to ${toDate}).csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    setCsvDialog(false);
  };

  const sessions = user && user.sessions ? user.sessions : [];
  const totalSessionPages = Math.ceil(sessions.length / SESSIONS_PER_PAGE);
  const paginatedSessions = sessions.slice(
    (sessionPage - 1) * SESSIONS_PER_PAGE,
    sessionPage * SESSIONS_PER_PAGE
  );

  return (
    <AdminContainer>
      <div className="app-wrapper" style={{ marginTop: "-10px" }}>
        {loading ? (
          <div className="loader-view" style={{ height: 'calc(100vh - 259px)' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {user ? (
              <div className="dashboard animated slideInUpTiny animation-duration-3">
                {/* Header */}
                <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center" style={{ padding: '15px 25px', zIndex: 2 }}>
                  <div>
                    <h2 className="title mb-3 mb-sm-0">
                      Guest User <ChevronRightIcon /> {user.name || user.phone || 'N/A'}
                    </h2>
                  </div>
                  <div>
                    <Button variant="outlined" className={'text-primary mr-2'} onClick={exportCSV}>
                      Export CSV
                    </Button>
                    <Button variant="outlined" className={'text-primary'} onClick={() => navigate('/admin/guestUsers')}>
                      Back to List
                    </Button>
                  </div>
                </div>

                {/* User Details Card */}
                <div className="row">
                  <div className="col-12">
                    <div className="jr-card chart-user-statistics bg-primary darken-4 text-white">
                      <div className="orderDetails px-4 mb-4">
                        <Row className="pb-4 ml-2">
                          <Col xs={12} sm={12} xl={4} md={4} lg={4} className="orderDetailsMainCol">
                            <h3 style={{ fontSize: 15 }}>Guest User Details</h3>
                            <div className="p-1">
                              <i className="zmdi zmdi-account-o zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                {user.name || 'N/A'}
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-email zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                {user.email || 'N/A'}
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                {user.phone || 'N/A'}
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-city zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                {user.city || 'N/A'}{user.state ? `, ${user.state}` : ''}
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-balance zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                {user.company_name || 'N/A'}
                              </span>
                            </div>
                          </Col>
                          <Col xs={12} xl={4} sm={12} md={4} lg={4} className="orderDetailsMainCol">
                            <h3 style={{ fontSize: 15 }}>Insight's</h3>
                            <div className="p-1">
                              <i className="zmdi zmdi-globe zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Source&nbsp;-&nbsp;<span>{user.source || 'website'}</span>
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-format-align-justify zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Registered At&nbsp;-&nbsp;<span>{user.createdAt ? moment(user.createdAt).format('DD/MM/YYYY') : 'N/A'}</span>
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-time zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Last Visited&nbsp;-&nbsp;<span>{user.last_visited ? moment(user.last_visited).format('DD/MM/YYYY') : 'N/A'}</span>
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-check zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Verified&nbsp;-&nbsp;<span>{user.is_verified ? 'Yes' : 'No'}</span>
                              </span>
                            </div>
                          </Col>
                          <Col xs={12} xl={4} sm={12} md={4} lg={4} className="orderDetailsMainCol">
                            <h3 style={{ fontSize: 15 }}>Session Stats</h3>
                            <div className="p-1">
                              <i className="zmdi zmdi-layers zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Total Sessions&nbsp;-&nbsp;<span>{sessions.length}</span>
                              </span>
                            </div>
                            <div className="p-1">
                              <i className="zmdi zmdi-wifi zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                              <span className="align-self-center ml-1">
                                Active Sessions&nbsp;-&nbsp;
                                <span>
                                  {sessions.filter(s => s.logout_at && new Date(s.logout_at) > new Date()).length}
                                </span>
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sessions Section */}
                <div className="jr-card p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0" style={{ fontSize: 16 }}>
                      Sessions ({sessions.length})
                    </h3>
                    {totalSessionPages > 1 && (
                      <div className="text-muted" style={{ fontSize: 13 }}>
                        Showing {(sessionPage - 1) * SESSIONS_PER_PAGE + 1}-{Math.min(sessionPage * SESSIONS_PER_PAGE, sessions.length)} of {sessions.length}
                      </div>
                    )}
                  </div>

                  {paginatedSessions.length > 0 ? (
                    paginatedSessions.map((session, index) => {
                      const globalIndex = (sessionPage - 1) * SESSIONS_PER_PAGE + index;
                      const sessionNumber = sessions.length - globalIndex;
                      const isActive = session.logout_at && new Date(session.logout_at) > new Date();
                      const uniqueSearchLogs = session.searchLogs
                        ? session.searchLogs.filter((log, i, arr) =>
                            arr.findIndex(l => (l.key || '').toLowerCase() === (log.key || '').toLowerCase()) === i
                          )
                        : [];
                      const searchCount = uniqueSearchLogs.length;
                      const panelId = `session-${globalIndex}`;

                      return (
                        <Accordion
                          key={session._id || globalIndex}
                          expanded={true}
                          style={{ marginBottom: 8 }}
                        >
                          <AccordionSummary
                            style={{ minHeight: 48 }}
                          >
                            <div className="d-flex justify-content-between align-items-center w-100 pr-2">
                              <div className="d-flex align-items-center">
                                <span style={{ fontWeight: 600, fontSize: 14, marginRight: 10 }}>
                                  Session #{sessionNumber}
                                </span>
                                {isActive ? (
                                  <span className="badge text-uppercase text-white bg-green">Active</span>
                                ) : (
                                  <span className="badge text-uppercase text-white bg-red">Expired</span>
                                )}
                                <Chip
                                  label={`${searchCount} search${searchCount !== 1 ? 'es' : ''}`}
                                  size="medium"
                                  variant="outlined"
                                  style={{ marginLeft: 10 }}
                                />
                              </div>
                              <div className="text-muted" style={{ fontSize: 13 }}>
                                <i className="zmdi zmdi-time zmdi-hc-fw" />
                                {session.login_at ? moment(session.login_at).format('DD MMM YYYY, hh:mm A') : '-'}
                                {' — '}
                                {session.logout_at ? moment(session.logout_at).format('hh:mm A') : '-'}
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '8px 16px 16px 16px' }}>
                            {searchCount > 0 ? (
                              <div style={{ display: 'flex', flexWrap: 'wrap', margin: '-4px' }}>
                                {uniqueSearchLogs.map((log, logIndex) => (
                                  <Chip
                                    key={log._id || logIndex}
                                    label={log.key || '-'}
                                    variant="outlined"
                                    size="medium"
                                    style={{
                                      margin: 4,
                                      paddingTop:"2px",
                                      borderColor: log.search_type === 'exact' ? "#1a237e" : '#4caf50',
                                      color: log.search_type === 'exact' ? "#1a237e" : '#4caf50',
                                    }}
                                  />
                                ))}
                              </div>
                            ) : (
                              <span className="text-muted">No searches in this session</span>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  ) : (
                    <div className="text-center py-3">
                      <span className="text-muted">No sessions found</span>
                    </div>
                  )}

                  {/* Pagination */}
                  {totalSessionPages > 1 && (
                    <div className="d-flex justify-content-end mt-3">
                      <Pagination
                        count={totalSessionPages}
                        page={sessionPage}
                        onChange={handleSessionPageChange}
                        color="primary"
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="text-center mt-4">
                <p className="text-muted">Guest user not found</p>
              </div>
            )}
          </>
        )}
      </div>
    </AdminContainer>
  );
}

const mapStateToProps = ({ admin }) => {
  const { tempUserDetails, loading } = admin;
  return { tempUserDetails, loading };
};

export default connect(mapStateToProps, { getTempUserDetails })(GuestUserDetails);
